import React from 'react'
import {
  SourceNameFormProvider,
  SourceNameForProvider
} from './source-name-form-context'
import { SourceName } from '.'
import { AddSourceNameDialog } from './add-source-name-dialog'
import { EditSourceNameDialog } from './edit-source-name-dialog'

export interface SourceNameDialogProps {
  isOpen: boolean
  organizationUuid: string
  sourceIP: string
  sourceName: SourceName | undefined
  closeDialog: () => void
  refresh: () => Promise<any>
}

export const ManageSourceNameDialog: React.FC<SourceNameDialogProps> = ({
  organizationUuid,
  isOpen,
  sourceIP,
  sourceName,
  closeDialog,
  refresh
}) => {
  const SourceNameDialog = !sourceName
    ? AddSourceNameDialog
    : EditSourceNameDialog
  const defaultSourceName = sourceName
    ? sourceName
    : {
        id: '',
        name: '',
        cidrBlocks: [sourceIP],
        start: undefined,
        expiration: undefined
      }
  return (
    <SourceNameFormProvider
      sourceName={defaultSourceName as SourceNameForProvider}
    >
      <SourceNameDialog
        organizationUuid={organizationUuid}
        isOpen={isOpen}
        closeDialog={closeDialog}
        refresh={refresh}
      />
    </SourceNameFormProvider>
  )
}
